import styles from "./EvaluationDetail.module.css";

import { deleteSelfPublishing } from "../../../../Api/Backend/SelfPublishing";
import { useAuth } from "../../../../Context/AuthContext";

const PUBLISHING_METHOD_LABELS = {
  jabi: "자비 출판",
  "jabi-amazon": "자비 출판 + 아마존 킨들",
  amazon: "아마존 킨들",
};


function EvaluationDetail({ detailedData, onBackClick }) {
  const auth = useAuth();

  if (!detailedData) {
    return (
      <div className={styles.container}>정보 없음</div>
    );
  }

  const {
    selfPublishingId,
    title,
    author,
    submitter,
    email,
    name,
    phoneNumber,
    dateCreated,
    manuscriptStatus,
    bookFormat,
    numberOfCopies,
    numberOfPages,
    color,
    publishingMethod,
    serviceOptions,
    manuscriptFiles,
    additionalNotes
  } = detailedData;

  const formattedDate = new Date(dateCreated).toLocaleString("ko-KR", {
    year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
  });

  const handleDelete = async (selfPublishingId) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    await deleteSelfPublishing({
      auth,
      selfPublishingId,
      onSuccess: () => onBackClick(),
      onError: (e) => alert("삭제에 실패했습니다.")
    });
  };

  return (
    <div className={styles.container}>

      <div className={styles.card}>
        <div className={styles.headerRow}>
          <div className={styles.headerTitle}>
            <button className={styles.backBtn} onClick={onBackClick}>이전</button>
            <p className={styles.headerName}>{title || "출판 견적서"}</p>
          </div>
          <button
            onClick={() => handleDelete(selfPublishingId)}
            className={styles.deleteButton}
          >
            삭제
          </button>
        </div>
        <hr className={styles.divider} />
        <div className={styles.fields}>
          <div className={styles.field}>
            <label>저자명</label>
            <span>{author || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>출판 방식</label>
            <span>{PUBLISHING_METHOD_LABELS[publishingMethod] || publishingMethod || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>현재 상태</label>
            <span>{manuscriptStatus || "-"}</span>
          </div>
        </div>
      </div>

      <div className={styles.card}>
        <p className={styles.cardTitle}>제출자 정보</p>
        <div className={styles.fields}>
          <div className={styles.field}>
            <label>이름</label>
            <span>{name || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>이메일</label>
            <span>{email || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>연락처</label>
            <span>{phoneNumber || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>제출일</label>
            <span>{formattedDate}</span>
          </div>
        </div>
      </div>

      {/* <div className={styles.card}>
        <div className={styles.headerRow}>
          <div className={styles.headerTitle}>
            <button className={styles.backBtn} onClick={onBackClick}>이전</button>
            <p className={styles.headerName}>{title || "출판 견적서"}</p>
          </div>
          <button
            onClick={() => handleDelete(selfPublishingId)}
            className={styles.deleteButton}
          >
            삭제
          </button>
        </div>
        <hr className={styles.divider} />
        <div className={styles.fields}>
          <div className={styles.field}>
            <label>제출자</label>
            <span>{email || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>제출일</label>
            <span>{formattedDate}</span>
          </div>
          <div className={styles.field}>
            <label>저자명</label>
            <span>{author || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>출판 방식</label>
            <span>{PUBLISHING_METHOD_LABELS[publishingMethod] || publishingMethod || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>현재 상태</label>
            <span>{manuscriptStatus || "-"}</span>
          </div>
        </div>
      </div> */}

      <div className={styles.card}>
        <p className={styles.cardTitle}>원고 세부정보</p>
        <div className={styles.fields}>
          <div className={styles.field}>
            <label>책 규격</label>
            <span>{bookFormat?.size || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>규격 설명</label>
            <span>{bookFormat?.description || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>페이지 수</label>
            <span>{numberOfPages || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>요청 부수</label>
            <span>{numberOfCopies || "-"}</span>
          </div>
          <div className={styles.field}>
            <label>본문 컬러</label>
            <span>{color || "-"}</span>
          </div>
        </div>
      </div>

      <div className={styles.card}>
        <p className={styles.cardTitle}>업로드 원고 링크</p>
        <div className={styles.fileList}>
          {manuscriptFiles?.length > 0 ? manuscriptFiles.map((f, i) => (
            <a key={i} href={f.fileLink} target="_blank" rel="noreferrer" className={styles.fileItem}>
              <span>{f.fileName}</span>
              <span className={styles.extIcon}>↗</span>
            </a>
          )) : <p className={styles.empty}>첨부파일 없음</p>}
        </div>
      </div>

      <div className={styles.card}>
        <p className={styles.cardTitle}>서비스 항목</p>
        <div className={styles.serviceList}>
          {serviceOptions?.map((s) => (
            <div key={s.serviceOption.serviceOptionId} className={styles.serviceItem}>
              <strong>{s.serviceOption.title}</strong>
              <span>{s.serviceOption.unitPrice.toLocaleString()}원{s.serviceOption.unit && ` / ${s.serviceOption.unit}`} · 수량 {s.quantity}</span>
              <p>{s.serviceOption.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.card}>
        <p className={styles.cardTitle}>상담내용</p>
        <p className={styles.detailsText}>{additionalNotes?.trim() || "-(없음)-"}</p>
      </div>

    </div>
  );
}

export default EvaluationDetail;